'use client';

import { useTranslations } from 'next-intl';
import { Text } from '@portals/ui-kit';
import { EColors } from '@/_types';
import { useWindowSize } from '@/_hooks/use-window-size';
import { isMobile } from '@/_utils/is-mobile';

type TProps = {
  title: string;
};

export const SupportTitle = ({ title }: TProps) => {
  const translations = useTranslations();
  const { width } = useWindowSize();

  const isMobileWidth = isMobile(width);

  return (
    <Text
      color={isMobileWidth ? EColors.WHITE : EColors.BLACK}
      size="headline-m"
      text={translations(title)}
    />
  );
};
